export default __webpack_public_path__ + "static/media/Methodize_lp-circles-bg.482655e4.png";